import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const navigate = useNavigate();
  const { setUser } = useApp();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const run = async () => {
      if (!code || !state) { navigate("/login", { replace: true }); return; }
      try {
        const { data } = await api.post("/auth/google/callback", { code, state, redirect_uri: window.location.origin + "/auth/google" });
        setUser(data);
        navigate(data.next || "/upload", { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "Login failed");
      }
    };
    run();
  }, []); // eslint-disable-line

  return (
    <div className="app-bg min-h-screen grid place-items-center text-amber-200 px-6" data-testid="google-callback">
      <div className="text-center">
        {error ? (
          <>
            <p className="text-rose-300 mb-4" data-testid="google-callback-error">{error}</p>
            <button onClick={() => navigate("/login", { replace: true })} className="btn-gold rounded-full px-6 py-2.5">Login</button>
          </>
        ) : (
          <>
            <Loader2 className="animate-spin mx-auto mb-4" size={32} />
            <p className="font-serif">AstroFriend…</p>
          </>
        )}
      </div>
    </div>
  );
}
